import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Het kopen van een nieuwbouwwoning is een spannende en bijzondere gebeurtenis. Bij de aanschaf van uw woning moet u opeens beslissingen nemen over allerlei zaken, waar u meestal niet dagelijks mee te maken heeft. Om dit proces voor u te vergemakkelijken is dit portaal opgezet.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "U gaat in drie verschillende fases een aantal keuzes maken voor uw woning. Deze keuzes hebben betrekking op de hoofdopzet en de indeling (modulair en ruwbouw) en de inrichting en afwerking van de woning (afbouw). Elke fase heeft een sluitingsdatum, zoals vermeld op dit dashboard.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Standaard zorgen we voor een hoog afwerkingsniveau. En uw complete badkamer en toilet worden voorzien van sanitair en tegels. Het sanitair is van Villeroy en Boch en de kranen van het hoogwaardige merk Grohe. Liever een andere stijl? Dat kan. Om uw woning zo goed mogelijk aan te laten sluiten bij uw woonwensen zijn er tal van opties naast de standaard opties voor u klaargezet. In Woonon gaat u alle mogelijkheden ontdekken op het gebied van meer- en minderwerk voor uw nieuwe woning. En alles overzichtelijk, zodat u weet wat het kost. Het ontwerpen van uw woning wordt zo niet alleen heel erg leuk, maar ook nog eens heel erg eenvoudig. Naast online kunt u de producten ook bekijken in de Woonon showroom.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "Let op: u heeft tot de sluitingsdatum de tijd om uw keuzes door te geven of aan te passen. Uw keuzes worden direct na opdracht verwerkt in de bouwtekeningen van uw woning, zodat alles exact wordt uitgevoerd zoals u het wenst.", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Veel plezier bij het realiseren van uw woonwensen!", -1)

import { authStore } from '@/stores/auth'
import { useRouter } from 'vue-router'
import BuildingDetails from '@/components/dashboard/BuildingDetails.vue'
import NewsWidget from '@/components/dashboard/NewsWidget.vue'
import QuestionnaireWidget from '@/components/dashboard/QuestionnaireWidget.vue'
import { headerStore } from '@/stores/header'
import { generalStore } from '@/stores/general'
import BuildingDetailsMobile from '@/components/dashboard/BuildingDetailsMobile.vue'
import { ls } from '@/ls'
import { onMounted, ref, computed } from 'vue'
import EnergyComparisonWidget from '@/components/dashboard/EnergyComparisonWidget.vue'
import WoononVideoWidget from '@/components/dashboard/WoononVideoWidget.vue'
import WoononVideoPopup from '@/components/dashboard/WoononVideoPopup.vue'
import MessagesWidget from '@/components/dashboard/MessagesWidget.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

const router = useRouter()

const building = ref(null)

const welcomeMessage = computed(() => {
  if (authStore().restricted()) {
    return 'Welkom beste gebruiker!'
  } else {
    return `Welkom ${authStore().user.firstname} ${authStore().user.lastname}!`
  }
})

const configuratorVersion = computed(() => {
  return authStore().activeBuilding?.configurator_version || 1
})

onMounted(() => {
  building.value = ls.get('building')
})

function goToCurrentPhase () : void {
  if (!headerStore().ordersReceived.modular) {
    router.push({ name: configuratorVersion.value !== 1 ? 'v' + configuratorVersion.value + '/Modular' : 'Modular' })
  } else if (!headerStore().ordersReceived.carcass) {
    router.push({ name: configuratorVersion.value !== 1 ? 'v' + configuratorVersion.value + '/Carcass' : 'Carcass' })
  } else if (!headerStore().ordersReceived.completion) {
    router.push({ name: configuratorVersion.value !== 1 ? 'v' + configuratorVersion.value + '/Completion1' : 'Completion1' })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().dashboardMsg)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: _unref(generalStore)().dashboardMsg.type || 'info',
                class: "global-notification",
                message: _unref(generalStore)().dashboardMsg.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().dashboardMsg.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["type", "message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, { span: 24 }, {
        default: _withCtx(() => [
          (_unref(generalStore)().desktop)
            ? (_openBlock(), _createBlock(BuildingDetails, { key: 0 }))
            : (_openBlock(), _createBlock(BuildingDetailsMobile, { key: 1 }))
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { title: _unref(welcomeMessage) }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              (!_unref(headerStore)().ordersReceived.modular || !_unref(headerStore)().ordersReceived.carcass || !_unref(headerStore)().ordersReceived.completion)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    style: _normalizeStyle(_unref(generalStore)().desktop ? { marginRight: '8px' } : { margin: '0 8px 8px 0' }),
                    onClick: goToCurrentPhase
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Start met aanpassen")
                    ]),
                    _: 1
                  }, 8, ["style"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Summary' })))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Naar de samenvatting")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["title"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 8}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  (_unref(configuratorVersion) === 1)
                    ? (_openBlock(), _createBlock(NewsWidget, { key: 0 }))
                    : (_openBlock(), _createBlock(MessagesWidget, { key: 1 }))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(WoononVideoWidget)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (building.value?.ean_power)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(EnergyComparisonWidget)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(QuestionnaireWidget)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(WoononVideoPopup)
    ]),
    _: 1
  }))
}
}

})